import useIntakeSpec from '~repositories/hooks/use-intake-spec'

import { getConsultationIntakeSpec } from '../screens'
import { useConsultationData } from '../store'

/**
 * 이 상담이 쓰는 질문지 (증상 화면에서 정한 문진 버전 intake_version 을 따른다).
 * 버전을 정한 뒤에는 질문지를 다시 받지 않는다.
 */
export const useConsultationIntakeSpec = () => {
  const [{ intake_version }] = useConsultationData()
  const query = useIntakeSpec({ pinned: !!intake_version })
  return { ...query, data: getConsultationIntakeSpec(query.data, intake_version) }
}
